import React from "react";
import { StudentReport } from "../components/StudentReport";

export default function ProgressReport() {
  return (
    <div className="space-y-4" data-testid="progress-report-page">
      <div>
        <h1 className="font-display text-3xl tracking-tight text-[#0B1A35]">Gelişim Raporum</h1>
        <p className="text-sm text-slate-500 mt-1">Çözdüğün sorulara göre konu ve alt konu başarın, yanlışların ve haftalık gelişimin.</p>
      </div>
      <StudentReport url="/me/progress-report" />
    </div>
  );
}
